export default __webpack_public_path__ + "media/images/building_images/placeholder_hero-f1af90db182d147028aa62f4994197d3.png";